import React from 'react'
import './Tooltip.scss'

interface IProps {
  className?: string,
  header?:any,
    children?:any,
    'data-attribute'?: any,
}

const Tooltip = ({ className,header,children, 'data-attribute': dataAttribute }:IProps) => {
        return <div className={`tooltipContainer ${className}`} data-attribute={dataAttribute}>
        <div className='tooltipHeader'>
            {header}
        </div>
        <div className='tooltipBody'>
            {children}
        </div>
    </div>
}

export default Tooltip